
import React from 'react';
import { Nav } from 'react-bootstrap';
import './Lewa.css';
//<Nav.Link className="menu-link" href={process.env.PUBLIC_URL+"/katalog/?kat=/dada/11/"}>Podkatalog </Nav.Link>
export default function Lewa(prop) {
    console.log("nip:"+prop.nip);
    return (
        <Nav className="menu1">
            <Nav.Item className="menu">
                <Nav.Link className="menu-link" href={process.env.PUBLIC_URL+"/start"}>Start</Nav.Link>
                <Nav.Link className="menu-link" href={process.env.PUBLIC_URL+"/katalog/"}>Katalog </Nav.Link>
                <Nav.Link className="menu-link" href={process.env.PUBLIC_URL+"/ustawienia/" +prop.nip}>Ustawienia</Nav.Link>
            </Nav.Item>
        </Nav>
    );
}
